module.exports = __webpack_public_path__ + "img/asphalted_paved.8ee7f1f7.png";